// extracted by mini-css-extract-plugin
export default {"container":"mT11Y","videoWithSidePanel":"lTQRI","video":"PHXtc"};